import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Clock, Star, Users, Compass } from 'lucide-react';

interface TourFiltersProps {
  onFilterChange: (filters: TourFilters) => void;
  filters: TourFilters;
  onClose: () => void;
}

export interface TourFilters {
  duration: string | null;
  style: string | null;
}

const TourFilters: React.FC<TourFiltersProps> = ({ onFilterChange, filters, onClose }) => {
  const durationOptions = [
    { value: 'half-day', label: 'Half-day', icon: <Clock className="w-4 h-4" /> },
    { value: 'full-day', label: 'Full-day', icon: <Clock className="w-4 h-4" /> }
  ];

  const styleOptions = [
    { 
      value: 'must-do', 
      label: 'Must Do', 
      icon: <Star className="w-4 h-4" />,
      color: 'bg-red-100 text-red-800 hover:bg-red-200 border-red-200'
    },
    { 
      value: 'best-rated', 
      label: 'Best Rated', 
      icon: <Users className="w-4 h-4" />,
      color: 'bg-blue-100 text-blue-800 hover:bg-blue-200 border-blue-200'
    },
    { 
      value: 'off-the-beaten-path', 
      label: 'Off the Beaten Path', 
      icon: <Compass className="w-4 h-4" />,
      color: 'bg-green-100 text-green-800 hover:bg-green-200 border-green-200'
    }
  ];


  const updateFilter = (key: keyof TourFilters, value: any) => {
    const newFilters = {
      ...filters,
      [key]: filters[key] === value ? null : value
    };
    onFilterChange(newFilters);
  };

  return (
    <Card className="p-4 bg-transparent border-0 shadow-none">
      <div className="space-y-4">
        {/* Duration Filter */}
        <div>
          <h4 className="text-sm font-medium mb-2">Duration</h4>
          <div className="flex gap-2">
            {durationOptions.map((option) => (
              <Button
                key={option.value}
                variant="outline"
                size="sm"
                onClick={() => updateFilter('duration', option.value)}
                className={`flex items-center gap-2 transition-all duration-200 ${
                  filters.duration === option.value 
                    ? 'bg-primary/10 border-primary text-primary ring-2 ring-primary/20' 
                    : ''
                }`}
              >
                {option.icon}
                {option.label}
              </Button>
            ))}
          </div>
        </div>

        {/* Style Filter */}
        <div>
          <h4 className="text-sm font-medium mb-2">Tour Style</h4>
          <div className="flex flex-wrap gap-2">
            {styleOptions.map((option) => (
              <Button
                key={option.value}
                variant="outline"
                size="sm"
                onClick={() => updateFilter('style', option.value)}
                className={`flex items-center gap-2 transition-all duration-200 ${
                  filters.style === option.value 
                    ? 'bg-primary/10 border-primary text-primary ring-2 ring-primary/20' 
                    : option.color
                }`}
              >
                {option.icon}
                {option.label}
              </Button>
            ))}
          </div>
        </div>
      </div>

      {/* Validate Button */}
      <div className="mt-4 pt-4 border-t">
        <Button 
          onClick={onClose}
          className="w-full"
          size="sm"
        >
          {navigator.language.startsWith('fr') ? 'Valider' : 'Apply Filters'}
        </Button>
      </div>
    </Card>
  );
};

export default TourFilters;